import Macy from 'macy/dist/macy';
import Sortable from 'sortablejs';
import mapData from './data';
import { L, initializeMap } from '../shared/map';

document.addEventListener('DOMContentLoaded', () => {
  const mapSettings = {
    center: [55.751244, 37.618423],
    zoom: 5,
    zoomControl: false,
    dragging: false,
    trackResize: false,
    boxZoom: false,
    doubleClickZoom: false,
    keyboard: false,
    scrollWheelZoom: false,
    touchZoom: false,
  };
  const placesMap = initializeMap('places-map', mapSettings);
  const placesMarkersGroup = L.layerGroup().addTo(placesMap);

  const routeMap = initializeMap('route-map', mapSettings);
  const routeMarkersGroup = L.layerGroup().addTo(routeMap);
  const routeLineGroup = L.layerGroup().addTo(routeMap);

  const selectedFilters = [];
  const routePlaces = [];

  const masonry = Macy({
    container: '.roadgo-places',
    trueOrder: false,
    waitForImages: false,
    margin: 20,
    columns: 2,
  });

  const $placesTagsContainer = document.querySelector('.roadgo-tags');
  const $placesContainer = document.querySelector('.roadgo-places');
  const $routeContainer = document.querySelector('.roadgo-route');

  const renderPlacesList = () => {
    $placesContainer.innerHTML = '';
    masonry.reInit();

    mapData.places
      .filter(
        p =>
          !selectedFilters.length ||
          p.tags.some(t => selectedFilters.includes(t))
      )
      .forEach(p => {
        const $container = document.createElement('div');
        const $photo = document.createElement('div');
        const $img = document.createElement('img');
        const $info = document.createElement('div');

        $container.className = 'place-card grid-item';
        $photo.className = 'photo';
        $img.src = p.photo;
        $img.onload = () => {
          $img.classList.toggle('loaded', true);
        };
        $info.className = 'place-meta';
        $info.innerHTML = `<div>${
          p.name
        }</div><ul class='tag-list'><li>${p.tags.join('</li><li>')}</li></ul>`;

        $photo.appendChild($img);
        $container.appendChild($photo);
        $container.appendChild($info);
        $placesContainer.appendChild($container);
      });

    masonry.recalculate();
  };

  const renderMarker = (point, group) => {
    const circle = new L.CircleMarker([point.lat, point.lon], {
      radius: 8,
      color: '#ffa000',
      fillColor: 'white',
      fillOpacity: 0.95,
      interactive: false,
    });
    group.addLayer(circle);
  };

  const renderPlacesMap = () => {
    placesMarkersGroup.clearLayers();

    mapData.places
      .filter(
        p =>
          !selectedFilters.length ||
          p.tags.some(t => selectedFilters.includes(t))
      )
      .forEach(p => renderMarker(p, placesMarkersGroup));

    placesMap.fitBounds(mapData.places.map(p => [p.lat, p.lon]));
  };

  const renderRouteMap = () => {
    routeMarkersGroup.clearLayers();
    routeLineGroup.clearLayers();

    const bounds = [];

    routePlaces.forEach(rp => {
      if (rp.visible) {
        const place = mapData.places[rp.index];
        bounds.push([place.lat, place.lon]);
        renderMarker(place, routeMarkersGroup);
      }
    });
    routeMap.fitBounds(bounds);

    fetch('/directions', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ coordinates: bounds.map(b => b.reverse()) }),
    })
      .then(result => result.json())
      .then(result => {
        const data = result.features
          ? result.features[0].geometry.coordinates.map(c => [c[1], c[0]])
          : [];
        const path = new L.Polyline(data, {
          color: '#ffa000',
        });
        routeLineGroup.addLayer(path);

        routePlaces.forEach(rp => {
          if (rp.visible) {
            renderMarker(mapData.places[rp.index], routeMarkersGroup);
          }
        });
      });
  };

  const initPlacesView = () => {
    mapData.tags.forEach(t => {
      const $tag = document.createElement('div');

      $tag.innerHTML = `${t.name}<span>${t.count}</span>`;
      $tag.addEventListener('click', () => {
        const i = selectedFilters.indexOf(t.name);

        if (i > -1) {
          selectedFilters.splice(i, 1);
        } else {
          selectedFilters.push(t.name);
        }

        $tag.classList.toggle('active');
        renderPlacesList();
        renderPlacesMap();
      });
      $placesTagsContainer.appendChild($tag);
    });

    renderPlacesList();
  };

  const initRouteView = () => {
    mapData.places.forEach((p, i) => {
      const $container = document.createElement('div');
      const $photo = document.createElement('div');
      const $img = document.createElement('img');
      const $name = document.createElement('div');
      const $number = document.createElement('div');
      const $cross = document.createElement('div');

      $container.className = 'place-card grid-item';
      $photo.className = 'photo';
      $img.src = p.photo;
      $img.onload = () => {
        $img.classList.toggle('loaded', true);
      };
      $name.className = 'place-meta';
      $name.innerText = p.name;
      $number.className = 'place-number';
      $number.innerText = i + 1;
      $cross.className = 'place-remove';
      $cross.innerText = '✕';

      $cross.addEventListener('click', () => {
        const index = routePlaces.findIndex(rp => rp.index === i);

        routePlaces[index].visible = !routePlaces[index].visible;
        $cross.innerText = routePlaces[index].visible ? '✕' : '✓';
        $container.classList.toggle('disabled');

        renderRouteMap();
      });

      $photo.appendChild($img);
      $container.appendChild($photo);
      $container.appendChild($name);
      $container.appendChild($number);
      $container.appendChild($cross);
      $routeContainer.appendChild($container);

      routePlaces.push({ index: i, visible: true });
    });
  };

  const onSortRoutePlaces = event => {
    const $numbers = document.querySelectorAll('.place-number');

    [...$numbers].forEach((n, i) => {
      n.innerText = i + 1;
    });

    const { oldIndex, newIndex } = event;
    routePlaces.splice(newIndex, 0, routePlaces.splice(oldIndex, 1)[0]);

    renderRouteMap();
  };

  new Sortable($routeContainer, {
    animation: 150,
    chosenClass: 'chosen-card',
    onEnd: onSortRoutePlaces,
  });

  window.addEventListener('resize', () => {
    placesMap._onResize();
    routeMap._onResize();
    masonry.recalculate();
  });

  window.addEventListener('load', () => {
    initPlacesView();
    initRouteView();

    renderRouteMap();
  });

  renderPlacesMap();
});
